//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
const newletters = require("./model-declaration-jsons/newletters");
const country_cites = require("./model-declaration-jsons/country_cites");
const contact_us = require("./model-declaration-jsons/contact_us");
const property_popups = require("./model-declaration-jsons/property_popups");
const property_enquiries = require("./model-declaration-jsons/property_enquiries");
const property_types = require("./model-declaration-jsons/property_types");
const about_us = require("./model-declaration-jsons/about_us");
const homes = require("./model-declaration-jsons/homes");
const properties = require("./model-declaration-jsons/properties");
const gallery_info = require("./model-declaration-jsons/gallery_info");
const contactus_info = require("./model-declaration-jsons/contactus_info");
const blogsCategory = require("./model-declaration-jsons/blog_category");
const city = require("./model-declaration-jsons/city");
const newsletter = require("./model-declaration-jsons/newsletter_display");
const developers = require("./model-declaration-jsons/developers");
const deal_categories = require("./model-declaration-jsons/deal_categories");
const deals_page = require("./model-declaration-jsons/deals_page");
const deals = require("./model-declaration-jsons/deals");
const models = [
  newletters,
  country_cites,
  contact_us,
  property_enquiries,
  property_popups,
  property_types,
  about_us,
  homes,
  properties,
  gallery_info,
  contactus_info,
  blogsCategory,
  city,
  newsletter,
  developers,
  deals_page,
  deal_categories,
  deals
];

module.exports = models;
